import { VideoHeroProps } from '@/components/blocks/VideoHero'
import dynamic from 'next/dynamic'
import {
  AlternateGridBlockRecord,
  CentredContentBlockRecord,
  FourColumnFeatureBlockRecord,
  TwoColumnFeatureGridWithListBlockRecord,
} from 'types'

const HowItWorksPageContent = ({ block, currentPath }) => {
  const type = block.__typename
  switch (type) {
    case 'VideoHeroRecord':
      const VideoHero = dynamic<VideoHeroProps>(() =>
        import('@/components/blocks/VideoHero').then((mod) => mod.VideoHero),
      )
      return <VideoHero record={block} videoTitle="How It Works - Video" />
    case 'CentredContentBlockRecord':
      const CentredContentBlock = dynamic<{ record: CentredContentBlockRecord; currentPath: string }>(() =>
        import('@/components/blocks/CentredContentBlock').then((mod) => mod.CentredContentBlock),
      )
      return <CentredContentBlock record={block} currentPath={currentPath} />
    case 'AlternateGridRecord':
      const AlternateGrid = dynamic<{ content: AlternateGridBlockRecord }>(() =>
        import('@/components/blocks/AlternateGrid').then((mod) => mod.AlternateGrid),
      )
      return <AlternateGrid content={block} />
    case 'TwoColumnFeatureGridWithListBlockRecord':
      const TwoColumnFeatureGridWithList = dynamic<{ content: TwoColumnFeatureGridWithListBlockRecord }>(() =>
        import('@/components/blocks/TwoColumnFeatureGridWithList').then((mod) => mod.TwoColumnFeatureGridWithList),
      )
      return <TwoColumnFeatureGridWithList content={block} />
    case 'FourColumnFeatureRecord':
      const FourColumnFeature = dynamic<{ content: FourColumnFeatureBlockRecord }>(() =>
        import('@/components/blocks/FourColumnFeatureBlock').then((mod) => mod.FourColumnFeature),
      )
      return <FourColumnFeature content={block} />
    default:
      return <></>
  }
}

export default HowItWorksPageContent
